import { publicFlowMessages } from './public-flow-messages.js';
import { remainingMessages } from './remaining-messages.js';
import { messages } from './messages.js';
import { marketingMessages } from './marketing-messages.js';
import { marketingFaqMessages } from './marketing-faq-messages.js';
import { technologyFaqMessages } from './technology-faq-messages.js';
import { technologyMessages } from './technology-messages.js';
import { mcpMessages } from './mcp-messages.js';
import { articleMessages } from './article-messages.js';

export const catalog = {
  ...mcpMessages,
  ...articleMessages,
  ...messages,
  ...marketingMessages,
  ...marketingFaqMessages,
  ...technologyMessages,
  ...technologyFaqMessages,
  ...publicFlowMessages,
  ...remainingMessages,
};
